import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function HomeAppBar() {
    return (
        <Box>
            <AppBar position="static">
                <Toolbar sx={{justifyContent: 'space-between'}}>
                    <Typography variant="h6" component="div">
                        TSS
                    </Typography>
                    <Button color="inherit">Logout</Button>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
